function present(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
export function buildClaimPackFacts(input) {
    const witnessParagraphs = [];
    const scheduleEntries = [];
    if (present(input.claimantName)) {
        witnessParagraphs.push(`The claimant provided the name ${input.claimantName.trim()} for this claim.`);
    }
    const vehicleParts = [];
    if (present(input.vehicleReg)) {
        vehicleParts.push(`vehicle registration ${input.vehicleReg.trim()}`);
    }
    if (present(input.vehicleMakeModel)) {
        vehicleParts.push(`vehicle description ${input.vehicleMakeModel.trim()}`);
    }
    if (vehicleParts.length > 0) {
        witnessParagraphs.push(`The claimant provided ${vehicleParts.join(' and ')}.`);
    }
    const incidentParts = [];
    if (present(input.incidentDate))
        incidentParts.push(`date ${input.incidentDate.trim()}`);
    if (present(input.incidentTime))
        incidentParts.push(`time ${input.incidentTime.trim()}`);
    const location = [input.locationAddress, input.locationPostcode]
        .filter(present)
        .map((value) => value.trim())
        .join(', ');
    if (location)
        incidentParts.push(`location ${location}`);
    if (incidentParts.length > 0) {
        const fact = `The claimant reports the incident details as ${incidentParts.join(', ')}.`;
        witnessParagraphs.push(fact);
        scheduleEntries.push(fact);
    }
    if (present(input.damageDescription)) {
        const fact = `The claimant reports the following damage: ${input.damageDescription.trim()}.`;
        witnessParagraphs.push(fact);
        scheduleEntries.push(fact);
    }
    if (input.hasDefectPhotos) {
        const fact = 'The claimant provided photographs of the reported defect.';
        witnessParagraphs.push(fact);
        scheduleEntries.push(fact);
    }
    if (input.hasDamagePhotos) {
        const fact = 'The claimant provided photographs of the reported vehicle damage.';
        witnessParagraphs.push(fact);
        scheduleEntries.push(fact);
    }
    if (input.hasRepairInvoice) {
        const fact = 'The claimant provided a repair invoice.';
        witnessParagraphs.push(fact);
        scheduleEntries.push(fact);
    }
    if (input.hasRepairQuote) {
        const fact = 'The claimant provided a repair quote.';
        witnessParagraphs.push(fact);
        scheduleEntries.push(fact);
    }
    scheduleEntries.push('Claim pack prepared for the claimant to review');
    return {
        witnessTitle: 'DRAFT WITNESS STATEMENT — FACT-BY-FACT REVIEW REQUIRED',
        witnessParagraphs,
        scheduleTitle: 'DRAFT SCHEDULE OF FACTS — FACT-BY-FACT REVIEW REQUIRED',
        scheduleEntries,
        statementOfTruthDirection: 'Do not sign the Statement of Truth until you have checked every fact and confirmed it is accurate.',
        preSigningChecklist: [
            'Check the claimant identity and address.',
            'Check every incident date, time and location detail.',
            'Check the vehicle registration, description and reported damage.',
            'Check that every listed document is present and accurately described.',
            'Delete or correct anything that is incomplete, uncertain or inaccurate.',
        ],
    };
}
